<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">public</v-icon>
      Geo-tags
    </HeaderBar>

    <v-layout row>
      <v-flex>
        <!-- <v-tabs> -->
        <!-- <v-tabs-slider></v-tabs-slider> -->
        <!-- <v-tab>
            Regions
          </v-tab> -->

        <!-- <v-tab>
            States
          </v-tab> -->

        <!-- <v-tab-item class="pa-2">
            <h1>Regions</h1>
            <GeoTag
              class="mb-2"
              :geotag="tag"
              v-for="tag in regionTags"
              :key="tag.id"
            />

            <v-form v-if="user.bohOrHigher">
              <v-layout column>
                <v-flex>
                  <h3>Add region</h3>
                </v-flex>
                <v-flex>
                  <v-text-field label="Region Name" v-model="newRegionName">
                  </v-text-field>
                  <v-btn @click="createNewRegion" :loading="pending"
                    >Save</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item> -->

        <!-- <v-tab-item> -->
        <h1>
          States
          <v-img
            v-if="statesLoading"
            max-width="45"
            :src="require('../../images/spinner.gif')"
          ></v-img>
        </h1>

        <GeoTag
          class="mb-2"
          :geotag="tag"
          v-for="tag in stateTags"
          :key="tag.id"
        />
        <v-form v-if="user.bohOrHigher">
          <v-layout column>
            <v-flex>
              <h3>Add state</h3>
            </v-flex>
            <v-flex>
              <v-text-field label="State Name" v-model="newStateName">
              </v-text-field>
              <v-btn @click="createNewState" :loading="pending">Save</v-btn>
            </v-flex>
          </v-layout>
        </v-form>

        <h1 class="mt-4">Regions</h1>

        <GeoTag
          class="mb-2"
          :geotag="tag"
          v-for="tag in regionTags"
          :key="`region-${tag.id}`"
        />
        <div v-if="regionTags.length === 0" class="mb-2">No regions yet</div>

        <v-form v-if="user.bohOrHigher">
          <v-layout column>
            <v-flex>
              <h3>Add region</h3>
            </v-flex>
            <v-flex>
              <v-text-field label="Region Name" v-model="newRegionName">
              </v-text-field>
              <v-select
                multiple
                chips
                deletable-chips
                v-model="newRegionStateIds"
                :items="stateTags"
                item-value="id"
                item-text="name"
                label="States in this region"
              ></v-select>
              <v-btn @click="createNewRegion" :loading="pending">Save</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <!-- </v-tab-item> -->
        <!-- </v-tabs> -->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import GeoTag from "@/components/geotags/geo-tag.vue";
export default {
  created() {
    this.statesLoading = true;
    this.$store.dispatch("geotags/getAll").then(() => {
      this.statesLoading = false;
    });
  },

  data() {
    return {
      tab: 0,
      newRegionName: "",
      newRegionStateIds: [],
      newStateName: "",
      pending: false,
      statesLoading: false
    };
  },

  computed: {
    ...mapState("geotags", ["geotags"]),
    ...mapGetters("geotags", ["stateTags", "regionTags", "defaultTags"]),
    ...mapState("userAuth", ["user"])
  },

  methods: {
    createNewRegion() {
      if (!this.newRegionName) {
        return;
      }
      this.pending = true;
      this.$store
        .dispatch("geotags/create", {
          name: this.newRegionName,
          segment_type: "region",
          member_segment_ids: this.newRegionStateIds
        })
        .finally(r => {
          this.newRegionName = "";
          this.newRegionStateIds = [];
          this.pending = false;
        });
    },

    createNewState() {
      if (!this.newStateName) {
        return;
      }
      this.pending = true;
      this.$store
        .dispatch("geotags/create", {
          name: this.newStateName,
          segment_type: "state"
        })
        .finally(r => {
          this.newStateName = "";
          this.pending = false;
        });
    }
  },

  components: {
    GeoTag
  }
};
</script>
